
import { useState } from "react";
import  "./AromaBreakIntensity.css";


const AromaBreakIntensity = ({data, handleChange, count})=>{
  const [val, setVal] = useState(data.aromabreakintensity===0?0:data.aromabreakintensity);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="breakradiocard" name="aromabreakintensity" onChange={onChangeValue}>
    <div class="breakrating-container">
      
      <div class="breakrating">
        <form class="breakrating-form-1" >

          <label for={`ABI1F-${count}`}>
          <input type="radio"  name="aromabreakintensity" class="break1" id={`ABI1F-${count}`}  value="1"  checked={'' + val === "1"} />
          <div className="circle">1</div>
          </label>

          <label for={`ABI2F-${count}`}>
        <input type="radio" name="aromabreakintensity" class="break2" id={`ABI2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>

          <label for={`ABI3F-${count}`}>
        <input type="radio" name="aromabreakintensity" class="break3" id={`ABI3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>

          <label for={`ABI4F-${count}`}>
        <input type="radio" name="aromabreakintensity" class="break4" id={`ABI4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>

        </label>

          <label for={`ABI5F-${count}`}>
        <input type="radio" name="aromabreakintensity" class="break5" id={`ABI5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>


    );
}

export default AromaBreakIntensity;